import React, { useState, useEffect } from 'react';
import { resolveDbConfig } from '../config/productDatabaseMap';

const LaunchClientApp = ({ onLaunchApp }) => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => { fetchClients(); }, []);

  const fetchClients = async () => {
    setLoading(true);
    try {
      const res = await fetch('/v1/clients');
      if (res.ok) {
        const data = await res.json();
        setClients((data.clients || []).filter(c => c.status === 'active'));
      } else { setClients(getDemoClients()); }
    } catch { setClients(getDemoClients()); }
    setLoading(false);
  };

  const getDemoClients = () => [
    { client_id: 'client_prab_001', company_name: 'Prab-Restaurant-Hospitality', plan: 'starter', tenant_type: 'INDEPENDENT', status: 'active', product_name: 'Restaurant Intelligence', product_type: 'Restaurant.Type-1' },
    { client_id: 'client_gt_lawn_001', company_name: 'GreenThumb-Lawn-Landscape', plan: 'starter', tenant_type: 'INDEPENDENT', status: 'active', product_name: 'Lawn & Landscape Ops', product_type: 'Lawn.Type-1' },
    { client_id: 'client_cb_hvac_001', company_name: 'CoolBreeze-HVAC-Services', plan: 'growth', tenant_type: 'INDEPENDENT', status: 'active', product_name: 'HVAC Service Management', product_type: 'HVAC.Type-1' },
    { client_id: 'client_sh_ins_001', company_name: 'SafeHaven-Insurance-Group', plan: 'enterprise', tenant_type: 'PARENT', status: 'active', product_name: 'Insurance Operations', product_type: 'Insurance.Type-1' },
    { client_id: 'client_sh_ral_001', company_name: 'SafeHaven-Insurance-Raleigh', plan: 'starter', tenant_type: 'SUB_CLIENT', status: 'active', product_name: 'Insurance Operations (Raleigh)', product_type: 'Insurance.Type-1' },
    { client_id: 'client_dm_plumb_001', company_name: 'DrainMaster-Plumbing-Network', plan: 'enterprise', tenant_type: 'PARENT', status: 'active', product_name: 'Plumbing Network Ops', product_type: 'Plumbing.Type-1' },
    { client_id: 'client_kmed_001', company_name: 'Kona-Med-Wellness', plan: 'growth', tenant_type: 'INDEPENDENT', status: 'active', product_name: 'Medical Wellness', product_type: 'Medical.Type-1' },
    { client_id: 'client_kauto_001', company_name: 'Kona-Auto-Valet', plan: 'starter', tenant_type: 'SUB_CLIENT', status: 'active', product_name: 'Auto Valet Services', product_type: 'Valet.Type-1' },
    { client_id: 'client_klog_001', company_name: 'Kona-Logistics-Smart', plan: 'enterprise', tenant_type: 'INDEPENDENT', status: 'active', product_name: 'Smart Logistics', product_type: 'Logistics.Type-1' },
    { client_id: 'client_3a1821e2', company_name: 'Sports-Avatar-Athletics', plan: 'growth', tenant_type: 'INDEPENDENT', status: 'active', product_name: 'AthleteEdge-LLM', product_type: 'Gym.Type-1' },
    { client_id: 'client_pnb_fin_001', company_name: 'Prabs-National-Bank', plan: 'enterprise', tenant_type: 'INDEPENDENT', status: 'active', product_name: 'BankRisk-LLM', product_type: 'Financial-Bank-Type1' },
  ];

  const filtered = clients.filter(c =>
    c.company_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    c.client_id?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const typeBadge = (type) => {
    const colors = { PARENT: '#FF9800', SUB_CLIENT: '#03A9F4', INDEPENDENT: '#4CAF50' };
    return (
      <span style={{
        background: colors[type] || '#666', color: '#fff', padding: '2px 8px',
        borderRadius: '12px', fontSize: '11px', fontWeight: 600,
      }}>{type}</span>
    );
  };

  return (
    <div style={{ padding: '24px', maxWidth: '900px', margin: '0 auto' }}>
      <h2 style={{ marginBottom: '4px' }}>▶️ Launch Client-Application</h2>
      <p style={{ color: '#666', marginBottom: '20px' }}>
        Select an active client to launch their AI-powered application with Boundary Guardrails, LLM, and Comm-AI layers
      </p>

      <input
        type="text" placeholder="Search by company name or client ID..."
        value={searchTerm} onChange={e => setSearchTerm(e.target.value)}
        style={{ width: '100%', padding: '10px 14px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', marginBottom: '16px', boxSizing: 'border-box' }}
        aria-label="Search clients to launch"
      />

      {loading ? <p>Loading active clients...</p> : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          {filtered.map(c => (
            <div key={c.client_id} style={{
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
              padding: '14px 16px', background: '#fff', border: '1px solid #e8e8e8',
              borderRadius: '10px', transition: 'box-shadow 0.15s',
            }}>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600, fontSize: '14px', marginBottom: '2px' }}>{c.company_name}</div>
                <div style={{ fontSize: '12px', color: '#888' }}>
                  <span style={{ fontFamily: 'monospace' }}>{c.client_id}</span>
                  <span style={{ margin: '0 8px' }}>•</span>
                  {typeBadge(c.tenant_type)}
                  <span style={{ margin: '0 8px' }}>•</span>
                  <span style={{ textTransform: 'capitalize' }}>{c.plan}</span>
                </div>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ color: '#4CAF50', fontSize: '12px', fontWeight: 600 }}>● Active</span>
                <button
                  onClick={() => onLaunchApp && onLaunchApp({
                    client_id: c.client_id,
                    company_name: c.company_name,
                    product_name: c.product_name || c.company_name,
                    product_type: c.product_type,
                    tenant_type: c.tenant_type,
                    plan: c.plan,
                    db_config: resolveDbConfig(c.db_config, c.product_type),
                  })}
                  style={{
                    padding: '8px 18px', background: '#2E7D32', color: '#fff', border: 'none',
                    borderRadius: '8px', fontSize: '13px', fontWeight: 700, cursor: 'pointer',
                    display: 'flex', alignItems: 'center', gap: '4px',
                  }}
                >
                  ▶ Launch
                </button>
              </div>
            </div>
          ))}
          {filtered.length === 0 && <p style={{ color: '#999', textAlign: 'center' }}>No active clients found</p>}
        </div>
      )}

      <p style={{ color: '#999', fontSize: '12px', marginTop: '16px' }}>
        {filtered.length} active client{filtered.length !== 1 ? 's' : ''} available for launch
      </p>
    </div>
  );
};

export default LaunchClientApp;
